import {
  fetchPostsByCategory,
  fetchPostsByDateAndCategory,
  fetchPostsSearch,
  getPostById,
} from './contentful'
import { PROJECT_CATEGORY, NEWS_CATEGORY, NEWS_EXTERNAL_CATEGORY } from '../constants/contentful'

const resolveCategory = (categoryNumOrString) => {
  const map = {
    2: PROJECT_CATEGORY,
    3: NEWS_CATEGORY,
    4: NEWS_EXTERNAL_CATEGORY,
  }
  return map[categoryNumOrString] || categoryNumOrString
}

export const fetchPostsPreview = (categoryNum, page, perPage, callback) =>
  fetchPostsByCategory(resolveCategory(categoryNum), page, perPage, callback)

export const fetchPostsDatePreview = (categoryNum, page, perPage, otherQueryParams, callback) =>
  fetchPostsByDateAndCategory(resolveCategory(categoryNum), page, perPage, otherQueryParams, callback)

export const fetchPostSearchPreview = (categoryNum, search, page, perPage, callback) =>
  fetchPostsSearch(resolveCategory(categoryNum), search, page, perPage, callback)

export const getPost = (id, callback) => getPostById(id, callback)
